const constantRoutes = [
  {
    name: 'page1',
    path: '/page1',
    component: () => import('../../components/Page1.vue')
  },
  {
    name: 'page2',
    path: '/page2',
    component: () => import('../../components/Page2.vue')
  },
  {
    name: 'page3',
    path: '/page3',
    component: () => import('../../components/Page3.vue')
  },
  {
    name: 'project',
    path: '/project',
    component: () => import('../../components/Project.vue')
  },
  {
    name: 'searchResult',
    path: '/searchResult',
    component: () => import('../../components/SearchResult.vue')
  }
]
export default constantRoutes
